<template>
  <div class="panorama-education-div">
    <div class="panorama-education w1200 pt80">
      <div class="lz-title1 mb8">全渠道经营场景</div>
      <p class="lz-desc EC3 T6 mb64 center">
        覆盖全渠道经营场景，占据每个流量入口，<br
          v-if="$store.state.sceneClassName === 'app'"
        />流量变现快速高效
      </p>
      <template v-if="$store.state.sceneClassName === 'app'">
        <div class="pe-swiper-box">
          <div class="pe-swiper-pagination"></div>
          <swiper :options="swiperOptions">
            <swiper-slide
              v-for="(item, index) in moduleChannel"
              :key="`cmb_${index}`"
              :style="{ backgroundImage: `url(${item})` }"
            >
              <div class="panorama-img">
                <img :src="item.icon" />
              </div>
              <p class="panorama-name">{{ item.title }}</p>
              <p class="panorama-sub-name">
                {{ item.desc + '，' + item.desc2 }}
              </p>
              <img class="panorama-swiper-img" :src="item.img" />
            </swiper-slide>
          </swiper>
        </div>
      </template>
      <ul v-else class="panorama-education-list">
        <li
          v-for="(item, index) in moduleChannel"
          :key="`scene_${index}`"
          :class="`mobile-education ${
            index === activeModuleScene ? 'active' : ''
          }`"
          @mouseover="moduleSceneOver(index)"
        >
          <div class="small-education-div">
            <div class="mobile-small-img">
              <i class="iconfont T3 EC2 iconicon_h"></i>
            </div>
            <p class="mobile-education-title">{{ item.title }}</p>
            <p class="mobile-education-sub">{{ item.desc }}</p>
            <p class="mobile-education-sub">{{ item.desc2 }}</p>
            <div class="mobile-education-img">
              <img :src="item.img" />
            </div>
          </div>
          <div class="big-mobile-education">
            <div class="pc-education-top">
              <div class="pc-small-img">
                <i class="iconfont iconicon_h"></i>
              </div>
              <div class="education-title-box">
                <p class="education-title">{{ item.title }}</p>
                <p class="education-sub-title">
                  {{ item.desc }}，{{ item.desc2 }}
                </p>
              </div>
            </div>
            <div class="education-img">
              <img :src="item.img" />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { moduleChannel } from '@/data.js';
import SwiperCore, { Pagination } from 'swiper';
SwiperCore.use([Pagination]);
export default {
  data() {
    return {
      moduleChannel,
      activeModuleScene: 2,
      swiperOptions: {
        loop: true,
        pagination: {
          el: '.pe-swiper-pagination',
          clickable: true
        },
        slidesPerView: 'auto',
        centeredSlides: true,
        watchSlidesProgress: true
      }
    };
  },
  methods: {
    moduleSceneOver(index) {
      this.activeModuleScene = index;
    }
  }
};
</script>

<style lang="scss">
.app {
  .panorama-education-div .panorama-education {
    width: auto;
    height: auto;
    padding: 0;
    margin-top: 0.48rem;
    .lz-title1 {
      font-size: 0.56rem;
      font-weight: 600;
      line-height: 0.72rem;
      padding-top: 1.28rem;
    }
    .lz-desc {
      font-size: 0.28rem;
      line-height: 0.44rem;
      color: #999;
      padding: 0.32rem 0.32rem 0.96rem;
      margin-bottom: 0;
    }
    .swiper-slide {
      width: 6.7rem;
      height: 8.16rem;
      box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.02),
        0 0.4rem 0.8rem 0 rgba(0, 0, 0, 0.04);
      border-radius: 0.08rem;
      background-color: #fff;
      transform-style: preserve-3d;
      position: relative;
      text-align: center;
    }
    .pe-swiper-box {
      position: relative;
      overflow: hidden;
      .swiper-container {
        padding-bottom: 1rem;
      }
    }
    .pe-swiper-pagination:not(ss) {
      bottom: 0.2rem;
      z-index: 7;
      text-align: center;
      width: 100%;
    }

    .swiper-container-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-custom,
    .swiper-pagination-fraction {
      bottom: 10px;
      left: 0;
      width: 100%;
    }
    .pe-swiper-pagination {
      position: absolute;
      text-align: center;
      -webkit-transition: 0.3s;
      transition: 0.3s;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      z-index: 10;
      .swiper-pagination-bullet {
        margin: 0 5px;
      }
    }
  }
  .panorama-education-div .swiper-slide .panorama-img {
    width: 0.64rem;
    height: 0.6rem;
    margin: 0.68rem auto 0.32rem;
  }

  .panorama-education-div .swiper-slide .panorama-name {
    text-align: center;
    font-size: 0.32rem;
    color: #353535;
    line-height: 0.44rem;
  }

  .panorama-education-div .swiper-slide .panorama-sub-name {
    text-align: center;
    font-size: 0.24rem;
    color: #353535;
    line-height: 0.36rem;
    margin-top: 0.08rem;
    margin-bottom: 0.64rem;
  }

  .panorama-education-div .swiper-slide .panorama-swiper-img {
    width: 5.5rem;
    height: 4.4rem;
  }

  .panorama-education-div .swiper-slide-next,
  .panorama-education-div .swiper-slide-prev {
    -webkit-transform: scale(0.95);
    transform: scale(0.95);
  }

  .panorama-education-div .swiper-pagination:not(ss) {
    bottom: -0.8rem;
    z-index: 7;
  }
}
</style>
